import { render, staticRenderFns } from "./ServiceDetailTabsExternal.vue?vue&type=template&id=244237c0&scoped=true&"
import script from "./ServiceDetailTabsExternal.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsExternal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsExternal.vue?vue&type=style&index=0&id=244237c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244237c0",
  null
  
)

export default component.exports